import { DDSButton } from "@web-monorepo/dds";
import { ReactNode } from "react";
import styles from "./ToolkitModal.module.css";

type ButtonProps = {
  /**
   * The name will get used for automated product events.
   * @see https://www.notion.so/classdojo/Automatic-Product-Events-for-Web-bfc580f10a914c3ba514e5ec20f8ef9e?pvs=4
   */
  "data-name": string;
  text: string;
  onClick: VoidFunction;
};

type ToolkitModalProps = {
  children: ReactNode;
  primaryButton: ButtonProps;
  secondaryButton: ButtonProps;
};

export default function ToolkitModal({ children, primaryButton, secondaryButton }: ToolkitModalProps) {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {children}
        <DDSButton
          variant="primary"
          size="large"
          width="fill"
          onClick={primaryButton.onClick}
          data-name={primaryButton["data-name"]}
        >
          {primaryButton.text}
        </DDSButton>
        {secondaryButton && (
          <DDSButton
            variant="secondary"
            className={styles.secondaryButton}
            onClick={secondaryButton.onClick}
            data-name={secondaryButton["data-name"]}
          >
            {secondaryButton.text}
          </DDSButton>
        )}
      </div>
    </div>
  );
}
